import React from 'react';
import { Tag, TagCloseIcon } from '@fiverr-private/data_display';
import { Typography } from '@fiverr-private/typography';

interface FilterControlTagProps {
  value: string;
  onClick: () => void;
}

export const FilterControlTag = ({ value, onClick }: FilterControlTagProps) => (
  <Tag size="sm" ariaLabel={value} onClick={onClick}>
    <Typography as="p" color="grey_1000">
      {value}
    </Typography>
    <TagCloseIcon />
  </Tag>
);
